import Nullstack from 'nullstack';
export default function IconTruckLoading({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-truck-loading",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M2 3h1a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2h15"
  }), "   ", Nullstack.element("rect", {
    x: "9",
    y: "6",
    width: "10",
    height: "8",
    rx: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "19",
    r: "2"
  }), " ");
}